module.exports = __webpack_public_path__ + "33f147ba8b7d0ad4490d5042a9c358f9.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/156.png
// module id = 1751
// module chunks = 2